import {CurrentUser} from "../types/auth";

export const canManageSiteContent = (user: CurrentUser | null): boolean =>
  !!user && !user.labels.includes('staff');
